'use-strict';

import moment from 'moment';
import { RootScope } from '../../../app.config';
import { CommentAPIService } from '../../../shared/api/comment-api.service';
import { Comment, ECommentType } from '../../../src/app/@shared-types/misc/comment';
import LogService from '../../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../toast/toast.service';

/* @ngInject */
export default class CommentController {
  public comment!: Comment;

  private $rootScope: RootScope;

  private commentApiService: CommentAPIService;

  private toastService: ToastService;

  private logService: LogService;

  public subtitle: string;

  constructor(
    $rootScope: RootScope,
    commentApiService: CommentAPIService,
    toastService: ToastService,
    logService: LogService,
  ) {
    this.$rootScope = $rootScope;
    this.commentApiService = commentApiService;
    this.toastService = toastService;
    this.logService = logService;

    this.subtitle = 'test';
  }

  $onInit(): void {
    let commentType = '';
    if (this.comment.type === ECommentType.IMPORTANT) commentType = 'Wichtig ';

    this.subtitle = `${commentType}${moment(this.comment.creation_date).format('DD.MM.YYYY hh:mm')}`;
  }

  public deleteComment = (
    commentId: number,
  ): void => {
    this.commentApiService
      .deleteComment(commentId)
      .then(() => {
        this.toastService.toast(ToastType.SUCCESS, 'Der Kommentar wurde gelöscht.');
        this.$rootScope.$emit('updateComments');
      })
      .catch((e) => this.logService.error(e));
  };
}
